import { useMutation, useQueryClient } from "react-query";
import servicesUtils from "../../../../utils/servicesUtils";

const useEditConversation = (workspaceId) => {
  const queryClient = useQueryClient();
  return useMutation(
    (payload) =>
      servicesUtils.postService(
        `/llm_orchestrator/workspaces/${workspaceId}/conversations/`,
        payload
      ),
    {
      onSuccess: (_, variables) => {
        if (variables.patient_id) {
          queryClient.invalidateQueries([
            "conversations",
            workspaceId,
            variables.patient_id,
          ]);
        } else {
          queryClient.invalidateQueries(["conversations", workspaceId]);
        }
      },
    }
  );
};
export default useEditConversation;
